import React, { useMemo } from "react";
import { Card, CardBody, Button } from "reactstrap";
import { AlertCircle } from "react-feather";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { getTaskProjectId } from "../../../redux/actions/task/task.action";

const MissingTimesheet = ({ tasks = [], empTask, getTaskProjectId }) => {
  const history = useHistory(); // ✅ MUST be here (top level)

  const { missingDays, monthLabel } = useMemo(() => {
    const today = new Date();
    
    // 🔹 Find the first day of the current month
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

    // 🔹 Build Mon–Fri dates for the entire month up to today
    const monthDays = [];
    let d = new Date(firstDay);
    while (d <= today) {
      const dayOfWeek = d.getDay();
      // Only add Mon(1) to Fri(5)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        monthDays.push(new Date(d));
      }
      d.setDate(d.getDate() + 1);
    }

    // 🔹 Dates that already have timesheet entries
    const filledDates = new Set(
      tasks.map(t =>
        new Date(t.workDate).toDateString()
      )
    );

    // 🔹 Missing days (Sort reversed so recent days are first, or keep ascending)
    const missing = monthDays
      .filter(d => !filledDates.has(d.toDateString()))
      .map(d => ({
        day: d.toLocaleDateString("en-US", { weekday: "short" }),
        date: d.toLocaleDateString("en-US", {
          weekday: "long",
          month: "short",
          day: "numeric"
        })
      }))
      .reverse(); // Optional: show recent missing dates first

    // 🔹 Month label
    const monthLabel = today.toLocaleDateString("en-US", {
      month: "long",
      year: "numeric"
    });

    return { missingDays: missing, monthLabel };
  }, [tasks]);

  const handleClick = () => {
    if (empTask && empTask.taskProjectInfo && empTask.taskProjectInfo.projectId) {
      getTaskProjectId(
        empTask.taskProjectInfo.projectId,
        empTask.taskProjectInfo.projectName,
        empTask.taskProjectInfo.status
      );
    }
    history.push("/taskManagment");
  };
  return (
    <Card className="h-100">
      <CardBody>
        {/* Header */}
      <div className="d-flex align-items-start gap-3 mb-3">

  {/* Icon */}
  <div className="icon-box bg-warning-light">
    <AlertCircle size={20} className="text-warning" />
  </div>

  {/* Title + Subtitle */}
  <div>
    <h5 className="mb-1 fw-semibold">
      Missing Timesheet Entries
    </h5>
    <p className="text-muted small mb-0">
      Month of {monthLabel}
    </p>
  </div>

</div>

        {/* Missing list */}
        <div className="mt-3" style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "5px" }}>
          {missingDays.length === 0 && (
            <div className="text-muted text-center py-3">
              🎉 All timesheets filled for this month
            </div>
          )}

          {missingDays.map((item, index) => (
            <div
              key={index}
              className="p-3 rounded mb-3 d-flex justify-content-between align-items-center"
              style={{ background: "#fff4e6" }}
            >
              <div>
                <strong>{item.day}</strong>
                <div className="text-muted small">
                  {item.date}
                </div>
              </div>
              <span className="badge bg-warning rounded-circle">
                &nbsp;
              </span>
            </div>
          ))}
        </div>

        <Button color="warning" className="w-100 mt-2"  onClick={handleClick}>
          Fill Timesheet
        </Button>
      </CardBody>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  empTask: state.taskReducer,
});

export default connect(mapStateToProps, { getTaskProjectId })(MissingTimesheet);
